import { Component, OnInit } from '@angular/core';

import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';
import { AdminService } from '../../../../../shared/services/admin/admin.service';

import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-lancamentos-futuros',
  templateUrl: './lancamentos-futuros.component.html',
  styleUrls: ['./lancamentos-futuros.component.scss']
})
export class LancamentosFuturosComponent implements OnInit {
  public error = null;
  public loaded = false;

  public conta = null;

  public lancamentosFuturos: any[];

  constructor(
    private localStorage: LocalStorageService,
    private adminService: AdminService
  ) { }

  ngOnInit() {
    this.obterConta();
    this.obterLancamentosFuturos();
  }

  obterConta() {
    const conta = this.localStorage.get('login');

    if (!conta || !conta.PersonId) {
      return;
    }

    this.conta = conta;
  }

  obterLancamentosFuturos() {
    this.adminService.getLancamentosFuturos(this.conta.PersonId).subscribe((data: any) => {
      this.loaded = true;

      this.lancamentosFuturos = this.agruparPorData(data.Lancamentos);

      this.lancamentosFuturos.forEach((lancamentoFuturo) => {
        lancamentoFuturo.Data = moment(lancamentoFuturo.Data).format('DD/MM/YYYY');
      });

      this.mostrarTabela();
    }, (err) => {
      console.error(err);
    });
  }

  agruparPorData(lancamentosFuturos) {
    if (!lancamentosFuturos) {
      return [];
    }

    const result = lancamentosFuturos.reduce(function (r, a) {
        if (!r[a.DataEsperada]) {
          r[a.DataEsperada] = { Data: a.DataEsperada, Items: [] };
        }

        r[a.DataEsperada].Items.push(a);

        return r;
    }, Object.create(null));

    const resultArray = this.obterTotal(Object.values(result));

    return resultArray;
  }

  obterTotal(lancamentos) {
    lancamentos.forEach((lancamento) => {
      let total = 0;
      lancamento.Items.forEach((item) => {
        total += item.ValorLiquido;
      });

      lancamento.TotalLiquido = total.toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
    });

    return lancamentos;
  }

  mostrarTabela() {
    const self = this;

    $(document).ready(function() {
      const table = $('#master-detail-table-lancamentos-futuros').DataTable({
        scrollX: true,
        destroy: true,
        paging: false,
        searching: false,
        processing: false,
        info: true,
        data: self.lancamentosFuturos,
        language: {
          emptyTable: ' ',
          info: '_START_ - _END_ de _MAX_',
        },
        initComplete: function() {
          self.loaded = true;

          if (!self.lancamentosFuturos) {
            $('#master-detail-table-lancamentos-futuros_info').html('0 - 0 de 0');
          }
        },
        columns: [
          {
            title: '',
            class: 'details-control',
            orderable: false,
            data: null,
            defaultContent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">' +
                              '<title>icon-mais</title>' +
                              '<line x1="3" y1="7" x2="11" y2="7" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                              '<line x1="7" y1="3" x2="7" y2="7" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                              '<line x1="7" y1="7" x2="7" y2="11" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                            '</svg>'
          },
          { title: 'Data', data: 'Data' },
          { title: 'Total Líquido', data: 'TotalLiquido' },
        ],
      });

      const detailRows = [];

      $('#master-detail-table-lancamentos-futuros tbody').on( 'click', 'tr td.details-control', function () {
        const tr = $(this).closest('tr');
        const row = table.row( tr );
        const idx = $.inArray( tr.attr('id'), detailRows );

        if ( row.child.isShown() ) {
          $('div.slider', row.child()).slideUp(function () {
            tr.removeClass('details');
            tr.removeClass('shown');
            row.child.hide();
          });

          detailRows.splice( idx, 1 );
        } else {

          tr.addClass('details');

          row.child('<button class="btn btn-registrar loading"></button>').show();

          tr.addClass('shown');
          row.child(self.format(row.data().Items)).show();
          $('div.slider', row.child()).slideDown();

          if ( idx === -1 ) {
              detailRows.push( tr.attr('id') );
          }
        }
      });

      table.on('draw', function () {
        $.each(detailRows, function ( i, id ) {
            $('#' + id + ' td.details-control').trigger( 'click' );
        });
      });
    });
  }

  format(d) {
    let tr = '';

    d.forEach((item) => {
      item.ValorBruto = item.ValorBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
      item.ValorLiquido = item.ValorLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });

      tr += '<tr>' +
              '<td>' + item.ValorBruto + '</td>' +
              '<td>' + item.ValorLiquido + '</td>' +
            '</tr>';
    });

    return  '<div class="slider">' +
              '<table style="width: 100%;">' +
                '<thead>' +
                  '<tr>' +
                    '<th>Valor Bruto</th>' +
                    '<th>Valor Líquido</th>' +
                  '<tr>' +
                '</thead>' +
                '<tbody>' +
                  tr +
                '</tbody>' +
              '</table>' +
            '</div>';
  }
}
